const informationFieldsForm = {
  minimumSellingUnit:
    "Hace referencia a la cantidad de m² que tiene una caja, un paquete o un rollo",
  comission:
    "Ten en cuenta que este porcentaje de utilidad se dividirá en partes iguales entre el profesional y la plataforma",
  name: "Este será el encabezado de tu producto",
  material:
    "Especifica por favor el material o materiales del producto. Ej: Latón, Madera, Mármol, etc",
  line: "Especifica por favor la línea a la que pertenece el producto. Ej: Clay, Grifería, etc",
  deliveryTime:
    "Al tiempo de entrega por favor sumar 3 días que tarda la transportadora en entregar los productos",
  color:
    "Selecciona por favor el color o el acabado más cercano a tu producto. Si tu producto incluye más de un color, por favor, selecciona la opción 'Multicolor'.",
  shippingAddress:
    "Esta será la dirección de la bodega donde se almacenará tu producto. Ten en cuenta que la transportadora recogerá el producto en esta dirección.",
};

export default informationFieldsForm;
